import { render, staticRenderFns } from "./MdDateIcon.vue?vue&type=template&id=c2c4f870"
import script from "./MdDateIcon.vue?vue&type=script&lang=js"
export * from "./MdDateIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports